import { API_URL } from '../../../components/config/BaseUrl';

export const GET_TOTAL_USERS_URL = `${API_URL}/wificall/getWorkgroupList`;
export const GET_RECENT_CALLS_URL = `${API_URL}/wificall/recentCalls`;
export const GET_WORKGROUPS_USER_BELONGS_TO_URL = `${API_URL}/web/usersip`;
export const LOGGED_IN_USER_URL = `${API_URL}/wificall/web/loggedOnUser`;
export const ADD_A_SUBSCRIBER_URL = `${API_URL}/wificall/subscribe`;
export const EDIT_USER_DETAILS = `${API_URL}/wificall/user`;
